import { keyframes, css } from 'styled-components';

/**
 * Shared visual idiom for every live-activity label in the chat —
 * "Pensando", "Pesquisando na web", "Executando comando", "Extraindo texto
 * dos arquivos", ... One look: a 15px leading icon (or ring) and a 0.88rem
 * medium label that shimmers while the activity is running and goes static
 * when it is done. Keep all indicator components on these pieces so the
 * layouts can't drift apart again.
 */

export const activityShimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

/** Gradient-sweep text effect for an ACTIVE (running) activity label.
 *  Deliberately subtle: a narrow, low-contrast highlight on a slow sweep —
 *  enough to read "running" at a glance without flashing at the user. */
export const shimmerText = css`
  /* Discreto de propósito: banda de contraste estreita (delta ~0.15) num
     sweep lento — o rótulo lê como "vivo" sem piscar na cara do usuário. */
  background: linear-gradient(
    90deg,
    ${({ theme }: any) =>
      theme.mode === 'dark' ? 'rgba(255,255,255,0.58)' : 'rgba(0,0,0,0.55)'} 38%,
    ${({ theme }: any) =>
      theme.mode === 'dark' ? 'rgba(255,255,255,0.74)' : 'rgba(0,0,0,0.7)'} 50%,
    ${({ theme }: any) =>
      theme.mode === 'dark' ? 'rgba(255,255,255,0.58)' : 'rgba(0,0,0,0.55)'} 62%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${activityShimmer} 4.2s linear infinite;
`;

/* Geometria comum de TODO indicador de atividade ao vivo do turno —
   "Pensando" (ThinkingGroup), "Extraindo N arquivos" (ExtractingFilesBlock) e o
   spinner/“Extraindo texto…” (LoadingMessage). Um turno com anexo troca de um
   para o outro várias vezes (envio → OCR → geração → raciocínio); com caixas
   diferentes o rótulo pulava 2-4px a cada troca ("tremia"). Mesma caixa, mesmo
   ponto de início do texto: trocar de indicador não move nada. */
export const activityRow = css`
  display: flex;
  flex-direction: column;
  margin: 4px 0;
  font-family: 'Sora', 'Lexend', sans-serif;
`;

/** Cabeçalho do indicador: padding simétrico (o fundo de hover não encosta no
 *  ícone) e margem negativa que devolve o ícone à coluna do texto. */
export const activityHeader = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding: 4px 8px;
  margin-left: -8px;
  border-radius: 6px;
  font-size: 0.88rem;
  font-weight: 500;
  color: ${({ theme }: any) => theme.text_secondary || theme.font_color};
`;

/** Slot de 15px do ícone/spinner. O -3px compensa o respiro interno dos SVGs
 *  MUI nesse tamanho; spinners de 13px centralizados caem no mesmo lugar. */
export const activityIconSlot = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-left: -3px;
`;
